import FastClick from '../../../vendor/assets/javascripts/fastclick';
window.FastClick = FastClick;